import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { CaseListComponent } from '../../../abacus/components/case-list.component'
import { InputType } from '../../../abacus/enums/input-type.enum'
import { Filter } from '../../../abacus/interfaces/filter.interface'
import { ResourceDefinition } from '../../../abacus/interfaces/resource-definition.interface'
import { Yield } from '../../../abacus/interfaces/yield.interface'
import { AuthService } from '../../../abacus/services/auth.service'
import { BreadcrumbService } from '../../../abacus/services/breadcrumb.service'
import { FilterService } from '../../../abacus/services/filter.service'
import { FlashMessageService } from '../../../abacus/services/flash-message.service'
import { ResourceService } from '../../../abacus/services/resource.service'
import { caseListTemplate } from '../../../abacus/templates/case-list.template'

import { CommonModule, NgIf } from '@angular/common'
import { RouterModule } from '@angular/router'
import { HasPermissionDirective } from '../../../abacus/directives/has-permission.directive'
import { CaseInputComponent } from '../../../abacus/elements/inputs/case-input/case-input.component'
import { MetaComponent } from '../../../abacus/elements/partials/meta/meta.component'
import { PaginationComponent } from '../../../abacus/elements/partials/pagination/pagination.component'
import { TableComponent } from '../../../abacus/elements/partials/table/table.component'
import { Status } from '../../../common/enums/status.enum'
import { toolUseCaseDefinition } from '../tool-use-case.definition'
import { toolUseCaseYields } from '../tool-use-case.yields'
import { EurosPipe } from 'src/app/abacus/pipes/euros.pipe'

@Component({
    template: caseListTemplate,
    imports: [CommonModule, EurosPipe, NgIf, HasPermissionDirective, CaseInputComponent, MetaComponent, TableComponent, PaginationComponent, RouterModule],
    standalone: true
})
export class ToolUseCaseListComponent
  extends CaseListComponent
  implements OnInit
{
  definition: ResourceDefinition = toolUseCaseDefinition
  yields: Yield[] = toolUseCaseYields

  filters: Filter[] = [
    {
      label: 'Search a tool use case',
      properties: {
        toolUseCaseIds: 'toolUseCaseIds'
      },
      inputType: InputType.MultiSearch,
      searchResources: [toolUseCaseDefinition],
      className: 'is-6'
    },
    {
      label: 'Status',
      property: 'status',
      placeholder: 'All status',
      inputType: InputType.Select,
      selectOptions: [
        {
          label: 'Published',
          value: Status.Published
        },
        {
          label: 'Pending',
          value: Status.Pending
        },
        {
          label: 'Rejected',
          value: Status.Rejected
        }
      ]
    }
  ]

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService,
    authService: AuthService,
    filterService: FilterService
  ) {
    super(
      router,
      activatedRoute,
      breadcrumbService,
      resourceService,
      flashMessageService,
      authService,
      filterService
    )
  }

  ngOnInit() {
    this.initListView()
  }
}
